import { useEffect, useState } from "react";

import Editor from "@monaco-editor/react";

export default function CodePasteModal({
	onUpdate,
	onAddToBottom,
}: {
	onUpdate: (value: string) => void;
	onAddToBottom: (value: string) => void;
}) {
	const [htmlCode, setHtmlCode] = useState("");

	useEffect(() => {
		setTimeout(() => {
			// Simulate loading delay
			setHtmlCode("\n");
		}, 500);
	}, []);

	return (
		<div className="">
			{/* description */}
			<div className="text-gray-600 text-sm px-4 pb-2">
				Paste your HTML code here. This will replace the current code in
				the editor.
			</div>

			<div className="w-[800px] p-4 border-r border-gray-200">
				{/* Code Editor */}
				<Editor
					height="60vh"
					defaultLanguage="html"
					defaultValue={htmlCode}
					options={{
						theme: "vs-dark",
						minimap: { enabled: false },
						formatOnPaste: true,
						formatOnType: true,
						lineNumbersMinChars: 3,
						lineNumbers: "on",
					}}
					onMount={(editor, monaco) => {
						editor
							?.getAction("editor.action.formatDocument")
							?.run();
					}}
					onChange={(value) => {
						setHtmlCode(value || "");
					}}
				/>
			</div>

			<div className="flex justify-end p-4">
				{/* Add to Bottom Button */}
				<button
					className="bg-green-500 text-white px-4 py-2 rounded mr-2"
					onClick={() => {
						onAddToBottom(htmlCode);
					}}>
					Add to Bottom
				</button>

				{/* Submit Button */}
				<button
					className="bg-blue-500 text-white px-4 py-2 rounded"
					onClick={() => {
						onUpdate(htmlCode);
					}}>
					Replace Code
				</button>
			</div>
		</div>
	);
}
